import type { TFunction } from "i18next";

import type { NoticeSummary } from "../../domain/noticeSummary";

/**
 * The summary as one sentence: each fragment translated first, then set into
 * its template. Each `t` call runs the patient-term post-processor on its own
 * text, so a fragment is swapped once and the sentence around it once.
 */
export function translateSummary(
    t: TFunction | ((key: string, values?: Record<string, unknown>) => string),
    summary: NoticeSummary
): string {
    const parts = Object.fromEntries(
        Object.entries(summary.parts).map(([name, part]) => [
            name,
            (t as (key: string, values?: Record<string, unknown>) => string)(
                part.key,
                part.values
            ),
        ])
    );
    return (t as (key: string, values?: Record<string, unknown>) => string)(
        summary.key,
        parts
    );
}
